module.exports = new __parcel__URL__("arrow-grey.d7b7790f.svg").toString();